import UnderConstruction from "../common/UnderConstruction";

export default function InventoryPurchase() {
  return <UnderConstruction title="Purchase Entry" />;
}
